import { createSlice } from '@reduxjs/toolkit';
import { IAnalyticsState } from '../../types/analytics/state';

const initialState: IAnalyticsState = {
  page: {
    pageType: 'Newbuilding_Finder_Form',
    siteType: 'desktop',
  },
};

export const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {},
});

export const { reducer: analyticsReducer } = analyticsSlice;
